import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { FormattedMessage } from 'react-intl';
import { Button } from '@printdeal/ui-library';

import useSystemPages from '../../../../../../../../hooks/useSystemPages';
import {
  dispatchAccountEvent,
  DispatchCategoriesAccount,
} from '../../../../../../../../helpers/dataLayerHelpers/accountDataLayerHelper';

interface ChooseAlternativeUploadProps {
  lineItemId: string;
  orderId: string;
  dispatchEventCategory: DispatchCategoriesAccount;
}

const ChooseAlternativeUpload = ({
  orderId,
  lineItemId,
  dispatchEventCategory = 'order_detail_interaction',
}: ChooseAlternativeUploadProps) => {
  const [accountDashboardPage] = useSystemPages('accountDashboard');

  return (
    <Button
      as={GatsbyLink}
      to={`${accountDashboardPage.path}/orders/${orderId}/upload/${lineItemId}`}
      variant="dim"
      iconBefore="image"
      iconAfter="chevron-right"
      onClick={() => { dispatchAccountEvent(dispatchEventCategory, 'open_alternative_upload'); }}
    >
      <FormattedMessage
        id="delivery.tool.alternativeUpload.odp"
        defaultMessage="Alternative upload button"
      />
    </Button>
  );
};

export default ChooseAlternativeUpload;
